export function cleanParams<T extends Record<string, any>>(obj: T): Partial<T> {
    const cleaned: Partial<T> = {};

    Object.keys(obj).forEach((key) => {
        const value = obj[key];

        if (value === null || value === undefined) return;

        if (typeof value === 'string' && value.trim() === '') return;

        cleaned[key as keyof T] = (typeof value === 'string'
            ? value.trim()
            : value) as any;
    });

    return cleaned;
}